import { SECONDARY_BG_COLOR } from 'shared/consts';
import { MAIN_COLOR, TEXT_COLOR } from 'shared/consts/styleValues';
import styled, { css } from 'styled-components';

export interface Button {
	$isSelected: boolean;
}

export const Container = styled.div`
	display: flex;
	position: fixed;
	bottom: 16px;
	z-index: 1;
	padding: 3px 5px;
	background: ${SECONDARY_BG_COLOR};
	border-radius: 17px;
	left: 16px;

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		left: 10px;
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		left: 10px;
	}
`;

export const Button = styled.button<Button>`
	background: ${MAIN_COLOR};
	color: white;
	font-weight: 400;

	${props =>
		!props.$isSelected &&
		css`
			background: transparent;
			color: ${TEXT_COLOR};
		`}

	padding: 10px 35px 10px 35px;

	border-radius: 17px;

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		padding: 10px 20px 10px 20px;
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		padding: 10px 25px 10px 35px;
	}
`;
